import { Descriptions, Space, Tag, Typography } from "antd";

const { Text } = Typography;

const AircraftInformationDetails = ({ data }) => {
  function joinList(list, fallback = "-") {
    if (!list || !list.length) return fallback;
    return list.join(", ");
  }

  function currency(n) {
    if (n === null || n === undefined || n === "") return null;
    const num = Number(n);
    if (Number.isNaN(num)) return null;
    const parts = num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `CA$ ${parts}`;
  }

  function yesNo(v) {
    return v ? "Yes" : "No";
  }

  return (
    <Descriptions bordered size="small" column={2}>
      <Descriptions.Item label="Registration">
        <Text>{data.registration || "-"}</Text>
      </Descriptions.Item>
      <Descriptions.Item label="Year / Make / Model">
        {[data.year, data.make, data.model].filter(Boolean).join(" ") || "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Passenger Seats">
        {data.passenger_seats ?? "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Charge for Aircraft Use">
        {yesNo(data.will_charge_for_aircraft_use)}
      </Descriptions.Item>

      <Descriptions.Item label="Hull Coverage Requested">
        {joinList(data.hull_coverage_requested)}
      </Descriptions.Item>
      <Descriptions.Item label="Liability Options">
        <Space wrap>
          {[
            ["CA$1,000,000", data.optional_1million_checked],
            ["CA$2,000,000", data.optional_2million_checked],
            ["CA$3,000,000", data.optional_3million_checked],
            ["CA$5,000,000", data.optional_5million_checked],
            ["CA$10,000,000", data.optional_10million_checked],
          ]
            .filter(([, on]) => on)
            .map(([label]) => (
              <Tag key={label}>{label}</Tag>
            ))}
          {!(
            data.optional_1million_checked ||
            data.optional_2million_checked ||
            data.optional_3million_checked ||
            data.optional_5million_checked ||
            data.optional_10million_checked
          ) && <Text>-</Text>}
        </Space>
      </Descriptions.Item>

      <Descriptions.Item label="Configurations" span={2}>
        <Space wrap>
          {[
            [
              "Wheels (fixed)",
              data.wheels_fixed_gear_checkbox,
              data.wheels_fixed_gear_amount,
            ],
            [
              "Tailwheel",
              data.wheels_tailwheel_checkbox,
              data.wheels_tailwheel_amount,
            ],
            [
              "Retract",
              data.wheels_retract_checkbox,
              data.wheels_retract_amount,
            ],
            ["Floats", data.floats_checkbox, data.floats_amount],
            ["Skis", data.skis_checkbox, data.skis_amount],
            ["Amphibian", data.amphibian_checkbox, data.amphibian_amount],
            ["Helicopter", data.helicopter_checkbox, data.helicopter_amount],
          ]
            .filter(([, on]) => on)
            .map(([label, , amt]) => {
              const c = currency(amt);
              return (
                <Tag key={label}>
                  {label}
                  {c ? ` • ${c}` : ""}
                </Tag>
              );
            })}
          {!(
            data.wheels_fixed_gear_checkbox ||
            data.wheels_tailwheel_checkbox ||
            data.wheels_retract_checkbox ||
            data.floats_checkbox ||
            data.skis_checkbox ||
            data.amphibian_checkbox ||
            data.helicopter_checkbox
          ) && <Text>-</Text>}
        </Space>
      </Descriptions.Item>

      <Descriptions.Item label="Spares & Equipment">
        {data.spares_equipment_checkbox
          ? [currency(data.spares_equipment_amount), data.spares_equipment_details]
              .filter(Boolean)
              .join(" \u2022 ") || "-"
          : "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Last Annual">
        {data.last_aircraft_annual || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Horse Power / Engine">
        {data.horse_power || "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Additional Insured?">
        {yesNo(data.has_additional_insured)}
      </Descriptions.Item>
      <Descriptions.Item label="Lienholder?">
        {yesNo(data.has_lienholder)}
      </Descriptions.Item>

      {data.has_additional_insured ? (
        <>
          <Descriptions.Item label="Additional Insured Name">
            {data.additional_insured_name || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Additional Insured Address">
            {[
              data.additional_insured_address,
              data.additional_insured_city,
              data.additional_insured_province,
              data.additional_insured_postal_code,
            ]
              .filter(Boolean)
              .join(", ") || "-"}
          </Descriptions.Item>
        </>
      ) : null}

      {data.has_lienholder ? (
        <>
          <Descriptions.Item label="Lienholder Name">
            {data.lienholder_name || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Lienholder Address">
            {[
              data.lienholder_address,
              data.lienholder_city,
              data.lienholder_province,
              data.lienholder_postal_code,
            ]
              .filter(Boolean)
              .join(", ") || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Lien Amount">
            {currency(data.lienholder_amount) || "-"}
          </Descriptions.Item>
        </>
      ) : null}
    </Descriptions>
  );
};

export default AircraftInformationDetails;
